import {Tabs} from 'antd';
import {FormInstance} from 'antd/es/form';
import classNames from 'classnames';
import React, {useEffect, useState} from 'react';

import {IEntityMeta} from 'entities/metadata';
import {IFormEntityData} from 'modules/data/data-types';

import {EFormMode} from '../../form-types';
import {useFormElementsAvailability} from '../../hooks/check-form-elements-availability.hook';
import {Fields} from '../fields';

import './fields-with-tabs.less';

export interface IFieldsWithTabsProps {
    parentEntityName?: string;
    entityName?: string;
    formData?: IFormEntityData;
    meta?: IEntityMeta;
    mode?: EFormMode;
    form?: FormInstance;
}

export const FieldsWithTabs = ({
    formData,
    meta,
    parentEntityName,
    entityName,
    mode = EFormMode.CREATE,
    form,
}: IFieldsWithTabsProps) => {
    const [currentTab, setCurrentTab] = useState<string | undefined>(undefined);
    const {isEditable} = useFormElementsAvailability(mode, entityName);

    useEffect(() => {
        setCurrentTab(meta?.tabs && meta?.tabs[0]?.key);
    }, [meta?.tabs]);

    return (
        <div className="fields-with-tabs">
            <Tabs
                onChange={tab => {
                    setCurrentTab(tab);
                }}
                destroyInactiveTabPane
                defaultActiveKey={currentTab}
                type="card"
                className={classNames({'first-is-active': meta?.tabs?.length && meta.tabs[0].key === currentTab})}
            >
                {meta?.tabs?.map(entry => (
                    <Tabs.TabPane
                        tab={entry.title}
                        key={entry.key}
                        forceRender
                    >
                        <div className="form-fields">
                            <Fields
                                formMode={mode}
                                formData={formData}
                                parentEntityName={parentEntityName}
                                entityName={entityName}
                                list={meta.fields.filter(field => entry?.fieldKeys.includes(field.key))}
                                isEditable={isEditable}
                                form={form}
                            />
                        </div>
                    </Tabs.TabPane>
                ))}
            </Tabs>
        </div>
    );
};
